import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractDynamicComponent } from '@components/abstracts';
import { ConfirmationFormulaire } from '@components/confirmation-formulaire/models';

@Component({
  selector: 'app-confirmation-formulaire',
  templateUrl: './confirmation-formulaire.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationFormulaireComponent extends AbstractDynamicComponent<ConfirmationFormulaire> {}
